module.exports = __webpack_public_path__ + "img/dyzhww-banner-pic.472cf42e.png";